// 系统检测工具函数

export interface SystemInfo {
  os: 'windows' | 'macos' | 'linux' | 'unknown';
  architecture: 'intel' | 'arm64' | 'unknown';
  downloadUrl: string;
  fileName: string;
  displayName: string;
}

// 详细的系统检测函数
export const detectDetailedSystem = (): SystemInfo => {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  
  console.log('用户代理:', userAgent);
  console.log('平台信息:', platform);
  console.log('硬件并发数:', navigator.hardwareConcurrency);
  console.log('设备像素比:', window.devicePixelRatio);
  
  let os: SystemInfo['os'] = 'unknown';
  let architecture: SystemInfo['architecture'] = 'unknown';
  let downloadUrl = '';
  let fileName = '';
  let displayName = '';

  // 检测操作系统
  if (userAgent.includes('win')) {
    os = 'windows';
    downloadUrl = 'https://bot.farmmaster.asia/FarmMaster-Setup-3.2.5.exe';
    fileName = 'FarmMaster-Setup-3.2.5.exe';
    displayName = 'Windows';
  } else if (userAgent.includes('mac')) {
    os = 'macos';
    
    // 改进的 Mac 处理器类型检测
    
    // 方法1: 检查用户代理字符串中的特定标识
    if (userAgent.includes('apple') || userAgent.includes('arm') || userAgent.includes('m1') || userAgent.includes('m2') || userAgent.includes('m3')) {
      architecture = 'arm64';
      console.log('通过用户代理检测到 Apple Silicon');
    } else if (userAgent.includes('intel')) {
      architecture = 'intel';
      console.log('通过用户代理检测到 Intel');
    }
    
    // 方法2: 检查平台字符串
    if (architecture === 'unknown') {
      if (platform.includes('arm') || platform.includes('apple')) {
        architecture = 'arm64';
        console.log('通过平台信息检测到 Apple Silicon');
      } else if (platform.includes('intel')) {
        architecture = 'intel';
        console.log('通过平台信息检测到 Intel');
      }
    }
    
    // 方法3: 使用特征检测
    if (architecture === 'unknown') {
      // Apple Silicon 设备的特征
      const hasHighDPR = window.devicePixelRatio >= 2;
      const hasHighConcurrency = navigator.hardwareConcurrency >= 8;
      const hasModernFeatures = 'SharedArrayBuffer' in window;
      
      // 检查是否支持 WebGL 2.0 (Apple Silicon 通常支持)
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl2');
      const hasWebGL2 = !!gl;
      
      // 检查是否支持 Apple 特定的 API
      const hasAppleFeatures = 'webkit' in window && 'WebKitCSSMatrix' in window;
      
      console.log('特征检测:', {
        hasHighDPR,
        hasHighConcurrency,
        hasModernFeatures,
        hasWebGL2,
        hasAppleFeatures
      });
      
      // 如果是现代 Mac 设备且满足多个特征，可能是 Apple Silicon
      if ((hasHighDPR && hasHighConcurrency && hasModernFeatures && hasWebGL2) || hasAppleFeatures) {
        architecture = 'arm64';
        console.log('通过特征检测判断为 Apple Silicon');
      } else {
        // 保守策略：使用 universal 版本
        architecture = 'intel';
        console.log('使用保守策略，选择 Intel 版本');
      }
    }
    
    // 设置下载链接
    if (architecture === 'arm64') {
      downloadUrl = 'https://bot.farmmaster.asia/FarmMaster-2.8.1-arm64.dmg';
      fileName = 'FarmMaster-2.8.1-arm64.dmg';
      displayName = 'macOS (Apple 芯片)';
    } else {
      downloadUrl = 'https://bot.farmmaster.asia/FarmMaster-2.8.1-universal.dmg';
      fileName = 'FarmMaster-2.8.1-universal.dmg';
      displayName = 'macOS (Intel 芯片)';
    }
    
  }  else {
    // 未知系统默认提供 Windows 版本
    downloadUrl = 'https://bot.farmmaster.asia/FarmMaster-Setup-3.2.5.exe';
    fileName = 'FarmMaster-Setup-3.2.5.exe';
    displayName = '未知系统 (Windows 版本)';
  }

  const result = { os, architecture, downloadUrl, fileName, displayName };
  console.log('最终检测结果:', result);
  
  return result;
};

// 简化的快速检测函数
export const quickDetectSystem = (): Omit<SystemInfo, 'displayName'> => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  if (userAgent.includes('win')) {
    return {
      os: 'windows',
      architecture: 'unknown',
      downloadUrl: 'https://bot.farmmaster.asia/FarmMaster-Setup-3.2.5.exe',
      fileName: 'FarmMaster-Setup-3.2.5.exe'
    };
  } else if (userAgent.includes('mac')) {
    // 对于 Mac，默认使用 universal 版本以确保兼容性
    return {
      os: 'macos',
      architecture: 'intel',
      downloadUrl: 'https://bot.farmmaster.asia/FarmMaster-2.8.1-universal.dmg',
      fileName: 'FarmMaster-2.8.1-universal.dmg'
    };
  } else {
    return {
      os: 'unknown',
      architecture: 'unknown',
      downloadUrl: 'https://bot.farmmaster.asia/FarmMaster-Setup-3.2.5.exe',
      fileName: 'FarmMaster-Setup-3.2.5.exe'
    };
  }
};